/**
 * Regex pattern for valid routes: /company/{alias}/site/{alias}[/...]
 */
const VALID_ROUTE_PATTERN = /^\/company\/[\w-]+\/site\/[\w-]+(\/[\w\-./]*)?$/i;

const isSafeInternalRoute = (url: string): boolean => {
    if (!url || typeof url !== 'string') {
        return false;
    }

    // Reject protocol-relative URLs (//example.com) and absolute URLs (http://)
    if (!url.startsWith('/') || url.startsWith('//')) {
        return false;
    }

    // Reject URLs with protocol schemes to prevent open redirects
    if (url.includes('://')) {
        return false;
    }

    return VALID_ROUTE_PATTERN.test(url);
};

/**
 * Safely navigates to an internal route after validation.
 * If the URL is not a valid internal route, falls back to the provided fallback URL.
 *
 * @param url The URL to navigate to
 * @param fallbackUrl Optional fallback URL if validation fails
 * @returns true if navigation was performed, false if validation failed
 */
export const safeNavigate = (url: string, fallbackUrl?: string): boolean => {
    if (isSafeInternalRoute(url)) {
        window.location.href = url;
        return true;
    }

    if (fallbackUrl && isSafeInternalRoute(fallbackUrl)) {
        window.location.href = fallbackUrl;
        return true;
    }

    return false;
};
